import React from 'react'

import Category from './Category'

import { findTutorCategories } from './data'

const Categories = ({ value, onChange }) => {
  const categoriesContent = findTutorCategories.map((item) => {
    return (
      <Category key={item.slug} category={item} isActive={item.slug === value} onFocus={onChange} />
    )
  })

  return (
    <section
      aria-labelledby="find-tutor-categories-heading"
      className="flex flex-col mt-[24px] w-full"
    >
      <h2 id="find-tutor-categories-heading" className="text-lg text-[#FDFDFD] font-semibold">
        Category
      </h2>

      <div className="flex justify-center items-center gap-2.5 mt-2">{categoriesContent}</div>
    </section>
  )
}

export default Categories
